declare global {
  interface Window {
    __vaadin_router__?: Router;
  }
}

import { Commands, RedirectResult, RouteContext, Router } from '@vaadin/router';

export let appRouter: Router;

export const setupRouter = (outlet: Element, isLoggedIn: () => Promise<boolean>) => {
  const router = new Router(outlet);

  interface RouteConfig {
    path: string;
    component: string;
    action: (context: RouteContext, commands: Commands) => Promise<RedirectResult | void | undefined>;
    children?: RouteConfig[];
  }

  const routes: RouteConfig[] = [
    {
      path: '/login',
      component: 'login-form',
      action: async (_ctx, commands) => {
        if (await isLoggedIn()) {
          return commands.redirect('/dashboard');
        }
        await import('./components/LoginForm');
      },
    },
    {
      path: '/register-family',
      component: 'register-wizard',
      action: async () => {
        await import('./components/register-family/RegisterWizard/RegisterWizard');
      },
    },
    {
      path: '/activate',
      component: 'activate-wizard',
      action: async () => {
        await import('./components/activate-user/ActivateWizard');
      },
    },
    {
      path: '/admin',
      component: 'va-admin-layout',
      action: async (_ctx, commands) => {
        if (!(await isLoggedIn())) return commands.redirect('/login');
        await import('./components/admin/admin-layout/adminLayout');
      },
    },
    {
      path: '/',
      component: 'app-shell',
      action: async (_ctx, commands) => {
        if (!(await isLoggedIn())) return commands.redirect('/login');
        await import('./components/AppShell');
      },
      children: [
        {
          path: '',
          component: 'dashboard-page',
          action: async (_ctx, commands) => {
            if (!(await isLoggedIn())) return commands.redirect('/login');
            return commands.redirect('/dashboard');
          },
        },
        {
          path: 'dashboard',
          component: 'dashboard-page',
          action: async (_ctx, commands) => {
            if (!(await isLoggedIn())) return commands.redirect('/login');
            await import('./components/dashboard-page/dashboard-page');
          },
        },
        {
          path: 'profile',
          component: 'family-profile',
          action: async (_ctx, commands) => {
            if (!(await isLoggedIn())) return commands.redirect('/login');
            await import('./components/FamilyProfile');
          },
        },
        {
          path: 'tasks',
          component: 'tasks-page',
          action: async (_ctx, commands) => {
            if (!(await isLoggedIn())) return commands.redirect('/login');
            await import('./components/tasks-page/tasks-page');
          },
        },
        {
          path: 'tasks/:id',
          component: 'task-details',
          action: async (_ctx, commands) => {
            if (!(await isLoggedIn())) return commands.redirect('/login');
            await import('./features/tasks/views/TaskDetails');
          },
        },
      ],
    },
  ];

  router.setRoutes(routes);
  window.__vaadin_router__ = router;
  appRouter = router;
  return router;
};
